const utilitiesGTM = {
  // Fires custom dataLayer push event for Google Tag Manager.
  gtmDataLayerPushEvent(event, category, action, label, userId) {
    return window.dataLayer.push({
      event,
      eventProps: {
        category,
        action,
        label,
      },
      // eslint-disable-next-line no-alert
      user_id: userId,
    });
  },

  // Parse through object of filters to push to GTM.
  parsePushEvent(filtersToPush, userId) {
    filtersToPush.forEach((filter) => {
      if (typeof filter.label === 'string' || typeof filter.label === 'number') {
        this.gtmDataLayerPushEvent('filter', 'Filter', filter.action, filter.label, userId);
      }
      else if (typeof filter.label === 'object' && Object.values(filter.label).length === 1) {
        const labelKey = Object.keys(filter.label);
        let actionValue;
        const valuesToModify = labelKey[0] === 'min' || labelKey[0] === 'max' || labelKey[0] === 'from' || labelKey[0] === 'to';

        if (valuesToModify) {
          actionValue = `${filter.action} ${this.capitalizeFirstLetter(labelKey[0])}`;
        }
        else {
          actionValue = filter.action;
        }

        this.gtmDataLayerPushEvent('filter', 'Filter', actionValue, filter.label[Object.keys(filter.label)], userId);
      }
      else if (typeof filter.label === 'object' && Object.values(filter.label).length >= 2) {
        this.loopThroughValuesToPush(filter, userId);
      }
    });
  },

  // Used for filter values that can have multiple values.
  loopThroughValuesToPush(filter, userId) {
    const filterValueKeys = Object.keys(filter.label);
    filterValueKeys.forEach((valKey) => {
      if (filter.label[valKey]) {
        let actionValue;
        const valuesToModify = valKey === 'min' || valKey === 'max' || valKey === 'from' || valKey === 'to';
        if (valuesToModify) {
          actionValue = `${filter.action} ${this.capitalizeFirstLetter(valKey)}`;
        }
        else {
          actionValue = filter.action;
        }

        this.gtmDataLayerPushEvent('filter', 'Filter', actionValue, filter.label[valKey], userId);
      }
    });
  },

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
};

export default utilitiesGTM;
